import { makeObservable, observable } from 'mobx';
import Bookkeeping from '../../model/Bookkeeping';
import CompanyStore from '../CompanyStore';

class VismaBookkeepingStore {
  companyStore: CompanyStore;

  history: Bookkeeping[] = [];

  loading = false;

  historyError: string | null = null;

  bookkeeper: string | undefined;

  constructor(companyStore: CompanyStore) {
    this.companyStore = companyStore;
    makeObservable(this, {
      history: observable,
      loading: observable,
      bookkeeper: observable,
      // getHistory: action,
    });
  }

  // getHistory() {
  //   console.log('Visma history');
  // }
}

export default VismaBookkeepingStore;
